var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"alt":_vm.product.title,"src":_vm.imageSrc},on:{"error":_vm.loadPlaceholder}})
}
var staticRenderFns = []

export { render, staticRenderFns }